export default import.meta.ROLLDOWN_FILE_URL_e_SQTc8mQlfZN1R_ZcR$4w